import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import GhoulaxHome from "@/pages/GhoulaxHome";
import ZyfleyHome from "@/pages/ZyfleyHome";
import Article from "@/pages/Article";
import AllArticles from "@/pages/AllArticles";
import Achievements from "@/pages/Achievements";
import StaticPage from "@/pages/StaticPage";
import SuggestEdit from "@/pages/SuggestEdit";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import EditorDashboard from "@/pages/EditorDashboard";
import QuizHub from "@/pages/QuizHub";
import QuizPlay from "@/pages/QuizPlay";
import RandomRedirect from "@/pages/RandomRedirect";
import SearchPage from "@/pages/SearchPage";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArticles from "@/pages/admin/AdminArticles";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import AdminSection from "@/pages/admin/AdminSection";
import QuizManager from "@/pages/admin/QuizManager";
import QuizEditor from "@/pages/admin/QuizEditor";
import NavigationManager from "@/pages/admin/NavigationManager";

function GlazingRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/quiz/glazing${search}`} replace />;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <Toaster position="bottom-right" />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/ghoulax" element={<GhoulaxHome />} />
              <Route path="/zyfley" element={<ZyfleyHome />} />
              <Route path="/:enc/all" element={<AllArticles />} />
              <Route path="/article/:slug" element={<Article />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/random" element={<RandomRedirect />} />
              <Route path="/achievements" element={<Achievements />} />
              <Route path="/quizzes" element={<QuizHub />} />
              <Route path="/quiz/:slug" element={<QuizPlay />} />
              <Route path="/glazing-quiz" element={<GlazingRedirect />} />
              <Route path="/suggest-edit" element={<SuggestEdit />} />
              <Route path="/about" element={<StaticPage page="about" />} />
              <Route path="/disclaimer" element={<StaticPage page="disclaimer" />} />
              <Route path="/privacy" element={<StaticPage page="privacy" />} />
              <Route path="/contact" element={<StaticPage page="contact" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              <Route path="/editor" element={<ProtectedRoute roles={["editor", "admin"]}><EditorDashboard /></ProtectedRoute>} />
              <Route path="/editor/articles/:slug" element={<ProtectedRoute roles={["editor", "admin"]}><ArticleEditor /></ProtectedRoute>} />

              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/articles" element={<ProtectedRoute><AdminArticles /></ProtectedRoute>} />
              <Route path="/admin/articles/:slug" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
              <Route path="/admin/drafts" element={<ProtectedRoute><AdminSection section="drafts" /></ProtectedRoute>} />
              <Route path="/admin/redirects" element={<ProtectedRoute><AdminSection section="redirects" /></ProtectedRoute>} />
              <Route path="/admin/broken-links" element={<ProtectedRoute><AdminSection section="broken-links" /></ProtectedRoute>} />
              <Route path="/admin/content-history" element={<ProtectedRoute><AdminSection section="content-history" /></ProtectedRoute>} />
              <Route path="/admin/users" element={<ProtectedRoute><AdminSection section="users" /></ProtectedRoute>} />
              <Route path="/admin/categories" element={<ProtectedRoute><AdminSection section="categories" /></ProtectedRoute>} />
              <Route path="/admin/images" element={<ProtectedRoute><AdminSection section="images" /></ProtectedRoute>} />
              <Route path="/admin/reports" element={<ProtectedRoute><AdminSection section="reports" /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute><AdminSection section="settings" /></ProtectedRoute>} />
              <Route path="/admin/activity" element={<ProtectedRoute><AdminSection section="activity" /></ProtectedRoute>} />
              <Route path="/admin/achievements" element={<ProtectedRoute><AdminSection section="achievements" /></ProtectedRoute>} />
              <Route path="/admin/quizzes" element={<ProtectedRoute><QuizManager /></ProtectedRoute>} />
              <Route path="/admin/quizzes/:slug" element={<ProtectedRoute><QuizEditor /></ProtectedRoute>} />
              <Route path="/admin/navigation" element={<ProtectedRoute><NavigationManager /></ProtectedRoute>} />
            </Route>
          </Routes>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
